import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import type { Language } from '@/types';

// UI translations
const translations = {
  en: {
    navigation: {
      home: 'Home',
      articles: 'Articles',
      places: 'Places',
      settings: 'Settings',
    },
    categories: {
      living: 'Living',
      services: 'Services',
      legal: 'Legal',
      lifestyle: 'Lifestyle',
      family: 'Family',
      couples: 'Couples',
      nature: 'Nature',
      culture: 'Culture',
    },
    ui: {
      featured: 'Featured',
      promoted: 'Promoted',
      noResults: 'No results found',
      loading: 'Loading...',
      error: 'Error loading data',
      favorite: 'Add to favorites',
      removeFavorite: 'Remove from favorites',
      favorites: 'Favorites',
      noFavorites: 'No favorites yet',
      search: 'Search',
      filter: 'Filter',
      language: 'Language',
      currency: 'Currency',
      usefulOrganizations: 'Useful Organizations',
      website: 'Website',
      phone: 'Phone',
      address: 'Address',
      location: 'Location',
      contact: 'Contact',
      relatedArticles: 'Related Articles',
    },
  },
  ru: {
    navigation: {
      home: 'Главная',
      articles: 'Статьи',
      places: 'Места',
      settings: 'Настройки',
    },
    categories: {
      living: 'Проживание',
      services: 'Услуги',
      legal: 'Юридическое',
      lifestyle: 'Образ жизни',
      family: 'Семья',
      couples: 'Пары',
      nature: 'Природа',
      culture: 'Культура',
    },
    ui: {
      featured: 'Избранное',
      promoted: 'Рекламируется',
      noResults: 'Ничего не найдено',
      loading: 'Загрузка...',
      error: 'Ошибка при загрузке данных',
      favorite: 'Добавить в избранное',
      removeFavorite: 'Удалить из избранного',
      favorites: 'Избранное',
      noFavorites: 'Избранного нет',
      search: 'Поиск',
      filter: 'Фильтр',
      language: 'Язык',
      currency: 'Валюта',
      usefulOrganizations: 'Полезные организации',
      website: 'Веб-сайт',
      phone: 'Телефон',
      address: 'Адрес',
      location: 'Местоположение',
      contact: 'Контакт',
      relatedArticles: 'Связанные статьи',
    },
  },
  pl: {
    navigation: {
      home: 'Strona główna',
      articles: 'Artykuły',
      places: 'Miejsca',
      settings: 'Ustawienia',
    },
    categories: {
      living: 'Mieszkanie',
      services: 'Usługi',
      legal: 'Prawne',
      lifestyle: 'Styl życia',
      family: 'Rodzina',
      couples: 'Pary',
      nature: 'Natura',
      culture: 'Kultura',
    },
    ui: {
      featured: 'Wyróżnione',
      promoted: 'Promowane',
      noResults: 'Nie znaleziono wyników',
      loading: 'Ładowanie...',
      error: 'Błąd podczas ładowania danych',
      favorite: 'Dodaj do ulubionych',
      removeFavorite: 'Usuń z ulubionych',
      favorites: 'Ulubione',
      noFavorites: 'Brak ulubionych',
      search: 'Szukaj',
      filter: 'Filtr',
      language: 'Język',
      currency: 'Waluta',
      usefulOrganizations: 'Przydatne organizacje',
      website: 'Strona internetowa',
      phone: 'Telefon',
      address: 'Adres',
      location: 'Lokalizacja',
      contact: 'Kontakt',
      relatedArticles: 'Powiązane artykuły',
    },
  },
};

// Get saved language or detect from browser
const getSavedLanguage = (): Language => {
  const saved = localStorage.getItem('language') as Language | null;
  if (saved && ['en', 'ru', 'pl'].includes(saved)) {
    return saved;
  }

  const browserLang = navigator.language.split('-')[0];
  if (['en', 'ru', 'pl'].includes(browserLang)) {
    return browserLang as Language;
  }

  return 'en';
};

i18n.use(initReactI18next).init({
  resources: translations,
  lng: getSavedLanguage(),
  fallbackLng: 'en',
  ns: ['translation'],
  defaultNS: 'translation',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
